import { render, staticRenderFns } from "./PageHeaderWrapper.vue?vue&type=template&id=54e3c1d6&"
import script from "./PageHeaderWrapper.vue?vue&type=script&lang=js&"
export * from "./PageHeaderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports